import { render, staticRenderFns } from "./address-form.vue?vue&type=template&id=00295cb0&scoped=true"
import script from "./address-form.vue?vue&type=script&lang=js"
export * from "./address-form.vue?vue&type=script&lang=js"
import style0 from "./address-form.vue?vue&type=style&index=0&id=00295cb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00295cb0",
  null
  
)

export default component.exports